export default __webpack_public_path__ + "static/media/saint-cloud3.b579a408.jpg";